import { HistoryOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React, { useState } from 'react';

import { TabsManager } from '../../../components/TabsManager';
import {
  DataChangeLogFiltersInput,
  DataChangeLogTableFragment,
} from '../../../graphql/api/generated';
import { IUseTabTableArgs, useTabTable } from '../../../hooks/useTabTable';

export interface IHistoryOfChangesModalProps {
  tabTables: IUseTabTableArgs<DataChangeLogTableFragment, DataChangeLogFiltersInput, any>[];
}

// Move tab hooks to their own component to ensure data is refetched whenever the modal is reopened
const HistoryOfChangesTabs: React.FC<IHistoryOfChangesModalProps> = (props) => {
  const { tabTables } = props;

  const tabs = tabTables.map(({ tableConfig, tableArgs }) => (
    useTabTable({ tableConfig, tableArgs }).tab
  ));

  return <TabsManager tabs={tabs} />;
};

export const HistoryOfChangesModal: React.FC<IHistoryOfChangesModalProps> = (props) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Modal
        title={null}
        visible={visible}
        onCancel={() => setVisible(false)}
        width='90%'
        maskClosable
        destroyOnClose
        footer={null}
        bodyStyle={{ padding: 10 }}
      >
        <HistoryOfChangesTabs {...props} />
      </Modal>
      <Button
        icon={<HistoryOutlined />}
        onClick={() => setVisible(true)}
      >
        History of Changes
      </Button>
    </>
  );
}
